import { TableColumnsType } from 'antd';
import {
  DataType0302,
  DataTypeB0101,
  DataTypeB0102,
  DataTypeB0103,
  DataTypeB0201,
  DataTypeB0202,
  DataTypeB0203,
  DataTypeB0301,
  DataTypeB0303,
  DataTypeB0401,
  DataTypeB0501,
  DataTypeB0502,
  DataTypeB0601,
  DataTypeB0701,
  ICTRiskFunctionServiceDetails,
  IIctRisk,
  IIctRiskExposure,
  IResponsibility,
  IRiskSource,
  IRoles,
} from 'store/ducks/Reportings/types';
import AdditionalInformation from 'components/AdditionalInformation/AdditionalInformation';
import * as Styled from '../components/Tables/Reporting/Reporting.styled';
import { ColumnsType } from 'antd/es/table';

export const columnsB0101: TableColumnsType<DataTypeB0101> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          LEI of the financial entity maintaining the register of information
          <span> - 0010</span>
        </p>

        <AdditionalInformation description="Identify the entity maintaining and updating the register of information using the LEI, 20-character, alpha- numeric code based on the ISO 17442 standard (alphanumerical)" />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'lei_entity',
    key: 'lei_entity',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Name of the financial entity - <span>0020</span>
        </p>
        <AdditionalInformation
          description="Legal name of the entity maintaining and updating the register of information
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Country of the financial entity -<span>0030</span>
        </p>
        <AdditionalInformation
          description="Identify the ISO 3166–1 alpha–2 code of the country where the license or the registration of the entity reported in the register of information has been issued.
(country)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'iso_code',
    key: 'iso_code',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of financial entity - <span>0040</span>
        </p>
        <AdditionalInformation
          description="Identify the type of entity using one of the options in the following closed list:
1.	credit institutions;
2.	payment institutions, including payment institutions exempted pursuant to Directive
(EU) 2015/2366 of the European Parliament and of the Council (1);
3.	account information service providers;
4.	electronic money institutions, including electronic money institutions exempted pursuant to Directive 2009/110/EC of the European Parliament and of the Council (2);
5.	investment firms;
6.	crypto-asset service providers authorised under Regulation (EU) 2023/1114 of the European Parliament and of the Council (3)
7.	issuers of asset-referenced tokens authorised under Regulation (EU) 2023/1114;
8.	central securities depositories;
9.	central counterparties;
10.	trading venues;
11.	trade repositories;
12.	managers of alternative investment funds;
13.	management companies;
14.	data reporting service providers;
15.	insurance and reinsurance undertakings;
16.	insurance	intermediaries,	reinsurance intermediaries and ancillary insurance intermediaries;
17.	institutions for occupational retirement provision;
18.	credit rating agencies;
19.	administrators of critical benchmarks;
20.	crowdfunding service providers;
21.	securitisation repositories.
22.	other financial entity;
Where the register of information is maintained at the group level by the parent undertaking, which is not itself subject to the obligation to maintain such register, i.e. it does not fall under the definition of financial entities set out in Article 2 of the Regulation (EU) 2022/2554 (e.g., financial holding company, mixed financial holding company or mixed-activity holding company) ‘Other financial entity’ option shall be chosen.

(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'entity_type',
    key: 'entity_type',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Competent Authority - <span>0050</span>
        </p>
        <AdditionalInformation
          description="Identify the competent authority referred to in Article 46 of Regulation (EU) 2022/2554 to which the register of information is reported.
(alphanumerical)
(mandatory in case of reporting)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'competent_authority',
    key: 'competent_authority',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Date of the reporting - <span>0060</span>
        </p>
        <AdditionalInformation
          description="Identify the date using ISO 8601 (yyyy–mm–dd) code of the date of reporting
(date)
(mandatory in case of reporting)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'reporting_date',
    key: 'reporting_date',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0102: TableColumnsType<DataTypeB0102> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          LEI of the financial entity - <span>0010</span>
        </p>
        <AdditionalInformation
          description="Identify the entity reported in the register of information using the LEI, 20-character, alpha-numeric code based on the ISO 17442 standard
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'lei_entity',
    key: 'lei_entity',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Name of the financial entity - <span>0020</span>
        </p>
        <AdditionalInformation
          description="Legal name of the entity reported in the register of information
(alphanumerical)."
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Country of the financial entity - <span>0030</span>
        </p>
        <AdditionalInformation
          description="Identify the ISO 3166–1 alpha–2 code of the country where the license or the registration of the financial entity reported in the register of information has been issued.
(country)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'country_name',
    key: 'country_name',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of financial entity - <span>0040</span>
        </p>
        <AdditionalInformation
          description="Identify the type of entity using one of the options in the following closed list:
1.	credit institutions;
2.	payment institutions, including payment institutions exempted pursuant to Directive (EU) 2015/2366;
3.	account information service providers;
4.	electronic money institutions, including electronic money institutions exempted pursuant to Directive 2009/110/EC;
5.	investment firms;
6.	crypto-asset service providers authorised under Regulation (EU) 2023/1114;
7.	issuers of asset-referenced tokens authorised under Regulation (EU) 2023/1114;
8.	central securities depositories;
9.	central counterparties;
10.	trading venues;
11.	trade repositories;
12.	managers of alternative investment funds;
13.	management companies;
14.	data reporting service providers;
15.	insurance and reinsurance undertakings;
16.	insurance intermediaries, reinsurance intermediaries and ancillary insurance intermediaries;
17.	institutions for occupational retirement provision;
18.	credit rating agencies;
19.	administrators of critical benchmarks;
20.	crowdfunding service providers;
21.	securitisation repositories;
22.	other financial entity;
23.	non-financial entity: ICT intra-group service provider;
24.	non-financial entity: other.
(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'entity_type',
    key: 'entity_type',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Hierarchy of the entity within the group (where applicable) -
          <span>0050</span>
        </p>
        <AdditionalInformation
          description="Determine the hierarchy of the entity in the consolidation using one of the options in the following closed list:
1.	The entity is the ultimate parent undertaking in the consolidation;
2.	The entity is the parent undertaking of a sub-consolidated part in the consolidation;
3.	The entity is a subsidiary in the consolidation and is not a parent undertaking of a sub-consolidated part;
4.	The entity is not part of a group;
5.	The entity is a service provider to which the entity (or the third- party service provider acting on its behalf) is outsourcing all its operational activities.
Where an entity fulfils more than one options from the closed list above, the higher- level option applicable to this entity shall be selected.
(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'hierarchy_in_group',
    key: 'hierarchy_in_group',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          LEI of the direct parent undertaking of the entity - <span>0060</span>
        </p>
        <AdditionalInformation
          description="Identify the direct parent undertaking of the entity reported in the register of information using the LEI, 20-character, alpha-numeric code based on the ISO 17442 standard
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'parent_lei',
    key: 'parent_lei',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Date of last update - <span>0070</span>
        </p>
        <AdditionalInformation
          description="Identify the date using ISO 8601 (yyyy–mm–dd) code of the date of the last update or modification made in the register of information in relation to the financial entity.
(date)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'date_of_last_update',
    key: 'date_of_last_update',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Date of integration in the Register of information - <span>0080</span>
        </p>
        <AdditionalInformation
          description="Identify the date using ISO 8601 (yyyy–mm–dd) code of the date of integration of the financial entity into the register of information
(date)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'integration_date',
    key: 'integration_date',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Date of deletion in the Register of information - <span>0090</span>
        </p>
        <AdditionalInformation
          description="Identify the date using ISO 8601 (yyyy–mm–dd) code of the date of deletion of the financial entity from the register of information.
Where the financial entity has not been deleted, ‘9999-12-31’ shall be reported.
(date)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'deletion_date',
    key: 'deletion_date',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Currency - <span>0100</span>
        </p>
        <AdditionalInformation
          description="Identify the ISO 4217 alphabetic code of the currency used for the preparation of the financial entity’s financial statements.
The currency reported shall be the same currency used by the financial entity for the preparation of the financial statements at entity, sub-consolidated or consolidated level, as applicable.
(currency)
(mandatory only if B_01.02.0110 is reported)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'currency',
    key: 'currency',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Value of total assets of the financial entity - <span>0110</span>
        </p>
        <AdditionalInformation
          description="Monetary value of total assets of the financial entity as reported in the financial entity’s annual financial statement of the year before the date of the last update of the register of information. Monetary value shall be reported in units.
Refer to Annex IV for the filling in this column.
(monetary)
(mandatory if the entity is a financial entity)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'total_assets',
    key: 'total_assets',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0103: TableColumnsType<DataTypeB0103> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Identification code of the branch - <span>0010</span>
        </p>
        <AdditionalInformation
          description="Identify a branch of a financial entity located outside its home country using a unique code for each branch. One of the options in the following closed list shall be used:
          (a)	LEI of the branch if unique for this branch and different from B_01.03.0020;
          (b)	other identification code used by the financial entity to identify the branch (where the LEI of the branch is equivalent to the one in template B_01.03.0020 or equivalent to the LEI of another branch).
          (alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'branch_identification_code',
    key: 'branch_identification_code',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          LEI of the financial entity head office of the branch -
          <span>0020</span>
        </p>
        <AdditionalInformation
          description="As reported in B_01.02.0010
Identify the financial entity head office of the branch, using the LEI, 20-character, alpha- numeric code based on the ISO 17442 standard
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'head_office_lei',
    key: 'head_office_lei',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Name of the branch - <span>0030</span>
        </p>
        <AdditionalInformation
          description="Identify the name of the branch
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'branch_name',
    key: 'branch_name',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Country of the branch - <span>0040</span>
        </p>
        <AdditionalInformation
          description="Identify the ISO 3166–1 alpha–2 code of the country where the branch is located
(country)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'country_id',
    key: 'country_id',
  },
  {
    title: 'Name of the financial entity',
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0201: TableColumnsType<DataTypeB0201> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Contractual arrangement reference number - <span>0010</span>
        </p>
        <AdditionalInformation
          description="Identify the contractual arrangement between the financial entity or, in case of a group, the group subsidiary and the direct ICT third-party service provider.
The contractual arrangement reference number is the internal reference number of the contractual arrangement assigned by the financial entity.
The contractual arrangement reference number shall be unique and consistent over time at entity, sub-consolidated and consolidated level, where applicable.
The contractual arrangement reference number shall be used consistently across all templates of the register of information when referring to the same contractual arrangement.
For the case where an entity is acting on behalf of a financial entity for all the activities of the financial entity including the ICT services (refer to recital 7) the contractual arrangement reference number can be the contractual arrangement between the entity and its direct ICT third-party service provider.
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'arrangement_reference_number',
    key: 'arrangement_reference_number',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of contractual arrangement - <span>0020</span>
        </p>
        <AdditionalInformation
          description="Identify the type of contractual arrangement by using one of the options in the following closed list:
1.	standalone arrangement;
2.	overarching / master contractual arrangement;
3.	subsequent or associated arrangement.
(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'contract_type',
    key: 'contract_type',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Overarching contractual arrangement reference number <span>0030</span>
        </p>
        <AdditionalInformation
          description="Not applicable if the contractual arrangement is the ‘overarching contractual arrangement’ or a ‘standalone arrangement’. In the other cases, report the contractual arrangement reference number of the overarching arrangement, which shall be equal to the value as reported in column B_02.01.0010 when reporting the overarching contractual arrangement.
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'overarching_reference_number',
    key: 'overarching_reference_number',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Currency of the amount reported in B.02.01.0050 - <span>0040</span>
        </p>
        <AdditionalInformation
          description="Identify the ISO 4217 alphabetic code of the currency used to express the amount in B_02.01.0050.
(currency)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'currency',
    key: 'currency',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Annual expense or estimated cost of the contractual arrangement for
          the past year - <span>0050</span>
        </p>
        <AdditionalInformation
          description="Annual expenses or estimated costs (or intragroup transfer) of the ICT services contractual arrangement for the past year. Monetary value shall be reported in units.
The annual expense or estimated cost shall be expressed in the currency reported in B_01.02.0040.
In case of an overarching arrangement with subsequent or associated arrangements, the sum of the annual expenses or estimated costs reported for the overarching arrangement and the subsequent or associated arrangements shall be equal to the total expenses or estimated costs for the overall contractual arrangement. There shall be no repetition or duplication of annual expenses or estimated costs. The following cases should be reflected:
(a) where the annual expenses or estimate costs are not determined at the level of the overarching arrangement (i.e. they are 0), the annual expenses or estimated costs shall be reported at the level of each subsequent or associated arrangements.
(b)	where the annual expenses or estimated costs cannot be reported for each of the subsequent or associated arrangements, the total annual expenses or estimated costs shall be reported at the level of the overarching arrangement.
(c)	where there are annual expenses or estimated costs related to each level of the arrangement, i.e. overarching and subsequent or associated, and that information is available, the annual expenses or estimated costs shall be reported without duplication at each level of the contractual arrangement.
(monetary)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'annual_expense',
    key: 'annual_expense',
  },
  {
    title: 'Name of the financial entity',
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0202: TableColumnsType<DataTypeB0202> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Contractual arrangement reference number - <span>0010</span>
        </p>
        <AdditionalInformation
          description="As reported in B_02.01.0010
(alphanumerical)
"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'contractual_arangement_ref_num',
    key: 'contractual_arangement_ref_num',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          LEI of the financial entity making use of the ICT service(s) -
          <span>0020</span>
        </p>
        <AdditionalInformation
          description="As reported in B_04.01.0020
Identify the entity making use of the ICT service(s) using the LEI, 20-character, alpha-numeric code based on the ISO 17442 standard
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'lei_of_the_entity_using_ict_service',
    key: 'lei_of_the_entity_using_ict_service',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Identification code of the ICT third-party service provider -
          <span>0030</span>
        </p>
        <AdditionalInformation
          description="Code to identify the ICT third-party service provider.
Where LEI is used, it shall be provided as a 20-character, alpha- numeric code based on the ISO 17442 standard.
Where EUID is used, it shall be provided as specified in Article 9 of the Commission Implementing Regulation (EU) 2021/1042.
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'ict_service_provider_code',
    key: 'ict_service_provider_code',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of code to identify the ICT third-party service provider -
          <span>0040</span>
        </p>
        <AdditionalInformation
          description="Type of code to identify the ICT third-party service provider reported in B_05.01.0010
          1.	‘LEI’ for LEI
          2.	‘EUID’ for EUID
          3.	‘Country Code’+Underscore+’Type of Code’ for non LEI and non EUID code
          Country Code: Identify the ISO 3166–1 alpha–2 code of the country of issuance of the other code to identify the ICT third- party service provider
          Type of Code:
          1.	CRN for Corporate registration number
          2.	VAT for VAT number
          3.	PNR for Passport Number
          4.	NIN for National Identity Number
          Only LEI or EUID shall be used for legal persons, as identified in B_05.01.0070, whereas alternative code may be used only for an individual acting in a business capacity.
          Only LEI shall be used for legal persons that are not established in the Union.
          (pattern)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'type_of_ict_service_provider_code',
    key: 'type_of_ict_service_provider_code',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Function identifier - <span>0050</span>
        </p>
        <AdditionalInformation
          description="As defined by the entity in B_06.01.0010
(pattern)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'function_identifier',
    key: 'function_identifier',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of ICT services - <span>0060</span>
        </p>
        <AdditionalInformation
          description="One of the types of ICT services referred to in Annex III
(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'type_of_ict_services',
    key: 'type_of_ict_services',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Start date of the contractual arrangement - <span>0070</span>
        </p>
        <AdditionalInformation
          description="Identify the date of entry into force of the contractual arrangement as stipulated in the contractual arrangement using the ISO 8601 (yyyy–mm–dd) code
(date)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'start_date',
    key: 'start_date',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          End date of the contractual arrangement - <span>0080</span>
        </p>
        <AdditionalInformation
          description="Identify the end date as stipulated in the contractual arrangement using the ISO 8601 (yyyy–mm–dd) code. Where the contractual arrangement is indefinite, it shall be filled in with ‘9999-12-31’. Where the contractual arrangement has been terminated on a date different than the end date, this shall be filled in with the termination date.
Where the contractual arrangement foresees a renewal, this shall be filled in with the date of the contract renewal as stipulated in the contractual arrangement.
(date)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'end_date',
    key: 'end_date',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Reason of the termination or ending of the contractual arrangement -
          <span>0090</span>
        </p>
        <AdditionalInformation
          description="Where the contractual arrangement has been terminated or ended, identify the reason of the termination or ending of the contractual arrangements using one of the options in the following closed list:
1.	Termination not for cause: The contractual arrangement has expired/ended and has not been renewed by any of the parties;
2.	Termination for cause: The contractual arrangement has been terminated, the ICT third-party service provider being in a breach of applicable law, regulations or contractual provisions;
3.	Termination for cause: The contractual arrangement has been terminated, due to the fact that impediments of the ICT third-party service provider capable of altering the supported function have been identified;
4.	Termination for cause: The contractual arrangement has been terminated due to weaknesses of the ICT third-party service provider regarding the management and security of sensitive data or information of any of the counterparties;
5.	Termination following a request by a competent authority: The contractual arrangement has been terminated following a request by a competent Authority.
6.	Other: The contractual arrangement has been terminated by any of the parties for any other reason than the reasons referred to in points 1 to 5.
(closed set of options)
(mandatory if the contractual arrangement is terminated)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'termination_reason',
    key: 'termination_reason',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Notice period for the financial entity making use of the ICT
          service(s) - <span>0100</span>
        </p>
        <AdditionalInformation
          description="Identify the notice period for terminating the contractual arrangement by the financial entity in a business-as-usual case. The notice period shall be expressed as number of calendar days from the counterparty’s receipt of the request to terminate the ICT service.
(natural number)
(mandatory if the ICT service is supporting a critical or important function)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'entity_notice_period',
    key: 'entity_notice_period',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Notice period for the ICT third-party service provider -
          <span>0110</span>
        </p>
        <AdditionalInformation
          description="Identify the notice period for terminating the contractual arrangement by the direct ICT third-party service provider in a business-as-usual case. The notice period shall be expressed as number of calendar days from the counterparty’s receipt of the request to terminate the ICT service.
(natural number)
(mandatory if the ICT service is supporting a critical or important function)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'provider_notice_period',
    key: 'provider_notice_period',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Country of the governing law of the contractual arrangement -
          <span>0120</span>
        </p>
        <AdditionalInformation
          description="Identify the country of the governing law of the contractual arrangement using the ISO 3166–1 alpha–2 code.
(country)
(mandatory if the ICT service is supporting a critical or important function)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'governing_law_country',
    key: 'governing_law_country',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Country of provision of the ICT services - <span>0130</span>
        </p>
        <AdditionalInformation
          description="Identify the country from where the ICT services are provided using the ISO 3166–1 alpha–2 code.
(country)
(mandatory if the ICT service is supporting a critical or important function)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'country_of_ict_services',
    key: 'country_of_ict_services',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Storage of data - <span>0140</span>
        </p>
        <AdditionalInformation
          description="Is the ICT service related to (or does it foresee) storage of data (even temporarily)? 
One of the options provided in the following closed list:
1.	Yes;
2.	No.
[Yes/No]
(mandatory if the ICT service is supporting a critical or important function)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'storage_of_data',
    key: 'storage_of_data',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Location of the data at rest (storage) - <span>0150</span>
        </p>
        <AdditionalInformation
          description="Identify the country of location of the data at rest (storage) using the ISO 3166–1 alpha–2 code.
If there are several countries of location, additional row(s) shall be used for each country.
(country)
(mandatory if ’Yes’ is reported in B_02.02.0140)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'data_location_storage',
    key: 'data_location_storage',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Location of management of the data (processing) - <span>0160</span>
        </p>
        <AdditionalInformation
          description="Identify the country of location of the management of the data (processing) using the ISO 3166–1 alpha–2 code.
If there are several countries of location, additional row(s) shall be used for each country.
(country)
(mandatory if the ICT service is based on or foresees data processing)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'data_location_processing',
    key: 'data_location_processing',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Sensitiveness of the data stored by the ICT third-party service
          provider - <span>0170</span>
        </p>
        <AdditionalInformation
          description="Identify the level of sensitiveness of the data stored or processed by the ICT third-party service provider using one of the options provided in the following closed list:
1.	Low
2.	Medium;
3.	High.
The most sensitive data take precedence: e.g. if both ‘Medium’ and ‘High’ apply, then ‘High’ shall be selected.
(closed set of options)
(mandatory if the ICT third-party service provider stores data and if the ICT service is supporting a critical or important function or material part thereof)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'data_sensitiveness',
    key: 'data_sensitiveness',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Level of reliance on the ICT service supporting the critical or
          important function. - <span>0180</span>
        </p>
        <AdditionalInformation
          description="One of the options in the following closed list shall be used:
1.	Not significant;
2.	Low reliance: in case of disruption of the services, the supported functions would not be significantly impacted (no interruption, no important damage) or disruption can be resolved quickly and with minimal impact on the functions supported;
3.	Material reliance: in case of disruption of the services, the supported functions would be significantly impacted if the disruption lasts more than a few minutes/ few hours, and the disruption may cause damages, but is still manageable;
4.	Full reliance: in case of disruption of the services, the supported functions would be immediately and severely interrupted/damaged, for a long period.
(closed set of options)
(mandatory if the ICT service is supporting a critical or important function or material part thereof)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'level_of_reliance',
    key: 'level_of_reliance',
  },
  {
    title: 'Name of the financial entity',
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0203: TableColumnsType<DataTypeB0203> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Contractual arrangement reference number - <span>0010</span>
        </p>
        <AdditionalInformation
          description="Reference number of the contractual arrangement between the entity making use of the ICT service(s) provided and the ICT intra-group service provider.
The contractual arrangement reference number shall be unique and consistent over time and across all the group.
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'arrangement_reference_number',
    key: 'arrangement_reference_number',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Contractual arrangement linked to the contractual arrangement referred
          in B.02.03.0010 - <span>0020</span>
        </p>
        <AdditionalInformation
          description="Contractual arrangement reference number of the contractual arrangement between the ICT intra-group service provider of the contractual arrangement in B_02.03.0010 and its direct ICT third-party service provider.
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'linked_contractual_arrangement',
    key: 'linked_contractual_arrangement',
    fixed: 'left',
  },
  {
    title: 'Link',
    width: 200,
    dataIndex: 'link',
    key: 'link',
    render: (value: boolean) => {
      return value ? 'Yes' : 'No';
    },
  },
  {
    title: 'Name of the financial entity',
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0301: TableColumnsType<DataTypeB0301> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Contractual arrangement reference number - <span>0010</span>
        </p>
        <AdditionalInformation
          description="As reported in B_02.02.0010
Identify the contractual arrangement reference number signed by the ICT third-party service provider
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'arrangement_reference_number',
    key: 'arrangement_reference_number',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          LEI of the entity signing the contractual arrangement -
          <span>0020</span>
        </p>
        <AdditionalInformation
          description="Identify the undertaking signing the contractual arrangement using the LEI, 20-character, alpha-numeric code based on the ISO 17442 standard or the EUID.
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: '',
    key: 'lei_entity_signing_contractual_arrangement',
    fixed: 'left',
  },
  {
    title: 'Link',
    width: 200,
    dataIndex: 'link',
    key: 'link',
    render: (value: boolean) => {
      return value ? 'Yes' : 'No';
    },
  },
  {
    title: 'Name of the financial entity',
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0302: TableColumnsType<DataType0302> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Contractual arrangement reference number - <span>0010</span>
        </p>
        <AdditionalInformation
          description="As reported in B_02.02.0010
Identify the contractual arrangement reference number signed by the ICT third-party service provider
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'contractual_arangement_ref_num',
    key: 'contractual_arangement_ref_num',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Identification code of ICT third-party service provider -
          <span>0020</span>
        </p>
        <AdditionalInformation
          description="As reported in B_05.01.0010
Code to identify the ICT third-party service provider as reported in B_05.01.0020 for that provider.
(alphanumerical)
"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'identification_code',
    key: 'identification_code',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of code to identify the ICT third-party service provider -
          <span>0030</span>
        </p>
        <AdditionalInformation
          description="Type of code to identify the ICT third-party service provider reported in B_05.01.0010
1.	‘LEI’ for LEI
2.	‘EUID’ for EUID
3.	‘Country Code’+Underscore+’Type of Code’ for non LEI and non EUID code
Country Code: Identify the ISO 3166–1 alpha–2 code of the country of issuance of the other code to identify the ICT third- party service provider
Type of Code:
1.	CRN for Corporate registration number
2.	VAT for VAT number
3.	PNR for Passport Number
4.	NIN for National Identity Number
Only LEI or EUID shall be used for legal persons, as identified in B_05.01.0070, whereas alternative code may be used only for an individual acting in a business capacity.
Only LEI shall be used for legal persons that are not established in the Union.
(pattern)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'type_of_code',
    key: 'type_of_code',
  },
  {
    title: 'Link',
    width: 200,
    dataIndex: 'link',
    key: 'link',
    render: (value: boolean) => {
      return value ? 'Yes' : 'No';
    },
  },
  {
    title: 'Name of the financial entity',
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0303: TableColumnsType<DataTypeB0303> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Contractual arrangement reference number - <span>0010</span>
        </p>
        <AdditionalInformation
          description="As reported in B_02.02.0010
Identify the reference number of the contractual arrangement signed by the entity for providing ICT service(s)
(alphanumerical)
"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'arrangement_reference_number',
    key: 'arrangement_reference_number',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          LEI of the financial entity providing ICT services - <span>0020</span>
        </p>
        <AdditionalInformation
          description="As reported in B_01.02.0010
Identify the entity providing ICT services using LEI, 20-character, alpha-numeric code based on the ISO 17442 standard.
(alphanumerical)
"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'ict_service_provider_lei',
    key: 'ict_service_provider_lei',
    fixed: 'left',
  },
  {
    title: 'Link',
    width: 200,
    dataIndex: 'link',
    key: 'link',
    render: (value: boolean) => {
      return value ? 'Yes' : 'No';
    },
  },
  {
    title: 'Name of the financial entity',
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0401: TableColumnsType<DataTypeB0401> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Contractual arrangement reference number - <span>0010</span>
        </p>
        <AdditionalInformation
          description="As reported in B_02.01.0010
Identify the reference number of the contractual arrangement in relation to the financial entity making use of the ICT services provided
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'arrangement_reference_number',
    key: 'arrangement_reference_number',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          LEI of the financial entity making use of the ICT service(s) -
          <span>0020</span>
        </p>
        <AdditionalInformation
          description="Identify the financial entity making use of the ICT service(s) using the LEI, 20-character, alpha-numeric code based on the ISO 17442 standard
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'lei_entity_making_use_ICT_service',
    key: 'lei_entity_making_use_ICT_service',
    fixed: 'left',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Nature of the financial entity making use of the ICT service(s) -
          <span>0030</span>
        </p>
        <AdditionalInformation
          description="One of the options in the following closed list shall be used:
1.	The financial entity making use of the ICT service(s) is a branch of a financial entity
2.	The financial entity making use of the ICT service(s) is not a branch
(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'nature_of_entity',
    key: 'nature_of_entity',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Identification code of the branch - <span>0040</span>
        </p>
        <AdditionalInformation
          description="Identification code of the branch as reported in B_01.03.0010
(alphanumerical)
(mandatory if the financial entity making use of the ICT service(s) is a branch of a financial entity (B_04.01.0030))"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'branch_identification_code',
    key: 'branch_identification_code',
  },
  {
    title: 'Name of the financial entity',
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0501: TableColumnsType<DataTypeB0501> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Identification code of ICT third-party service provider -
          <span>0010</span>
        </p>
        <AdditionalInformation
          description="Code to identify the ICT third-party service provider.
Where LEI is used, it shall be provided as a 20-character, alpha- numeric code based on the ISO 17442 standard.
Where EUID is used, it shall be provided as specified in Article 9 of the Commission Implementing Regulation (EU) 2021/1042.
(alphanumerical)
"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'identification_code_of_ICT_provider',
    key: 'identification_code_of_ICT_provider',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of code to identify the ICT third-party service provider -
          <span>0020</span>
        </p>
        <AdditionalInformation
          description="Type of code to identify the ICT third-party service provider reported in B_05.01.0010
            1.	‘LEI’ for LEI
            2.	‘EUID’ for EUID
            3.	‘Country Code’+Underscore+’Type of Code’ for non LEI and non EUID code
            Country Code: Identify the ISO 3166–1 alpha–2 code of the country of issuance of the other code to identify the ICT third- party service provider
            Type of Code:
            1.	CRN for Corporate registration number
            2.	VAT for VAT number
            3.	PNR for Passport Number
            4.	NIN for National Identity Number
            Only LEI or EUID shall be used for legal persons, as identified in B_05.01.0070, whereas alternative code may be used only for an individual acting in a business capacity.
            Only LEI shall be used for legal persons that are not established in the Union.
            (pattern)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'type_of_code',
    key: 'type_of_code',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Additional identification code of ICT third-party service provider -
          <span>0030</span>
        </p>
        <AdditionalInformation
          description="Additional code to identify the ICT third-party service provider, where available.
            (alphanumerical)
            (optional)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'additional_code',
    key: 'type_of_code',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of additional identification code of the ICT third-party service
          provider - <span>0040</span>
        </p>
        <AdditionalInformation
          description="The type of additional code to identify the ICT third-party service provider reported in B_05.01.0030:
            1.	‘LEI’ for LEI
            2.	‘EUID’ for EUID
            3.	CRN for Corporate registration number
            4.	VAT for VAT number
            5.	PNR for Passport Number
            6.	NIN for National Identity Number
            LEI or EUID shall be used for legal persons, as identified in B_05.01.0070, whereas alternative code may be used only for an individual acting in a business capacity.
            Only LEI shall be used for legal persons that are not established in the Union.
            (pattern)
            (mandatory, if B_05.01.0030 is reported)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'type_of_additional_code',
    key: 'type_of_code',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Legal name of the ICT third-party service provider - <span>0050</span>
        </p>
        <AdditionalInformation
          description="Legal name of the ICT third-party service provider as registered in business register in Latin, Cyrillic or Greek alphabets.
            (alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'legal_name',
    key: 'legal_name',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Name of the ICT third-party service provider in Latin alphabet -
          <span>0060</span>
        </p>
        <AdditionalInformation
          description="Name of the ICT third-party service provider in Latin alphabet.
Where the name of the ICT third-party service provider reported in B_05.01.0050 is in Latin alphabet, it shall be repeated also in this data field.
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'name_of_the_ICT_provider',
    key: 'name_of_the_ICT_provider',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of person of the ICT third-party service provider -
          <span>0070</span>
        </p>
        <AdditionalInformation
          description="One of the options in the following closed list shall be used:
1.	Legal person, excluding individuals acting in business capacity
2.	Individual acting in a business capacity
(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'type_of_person',
    key: 'type_of_person',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Country of the ICT third-party service provider’s headquarters -
          <span>0080</span>
        </p>
        <AdditionalInformation
          description="Identify the ISO 3166–1 alpha–2 code of the country in which the global operating headquarters of ICT third-party service provider are located (usually, this country is the country of tax residence).
(country)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'country',
    key: 'country',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Currency of the amount reported in RT.05.01.0070 - <span>0090</span>
        </p>
        <AdditionalInformation
          description="Identify the ISO 4217 alphabetic code of the currency used to express the amount in B_05.01.0100.
The currency reported shall be the same currency used by the financial entity for the preparation of the financial statements at entity, sub-consolidated or consolidated level, as applicable.
(currency)
(mandatory if B_05.01.0100 is reported)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'currency_reported',
    key: 'currency_reported',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Total annual expense or estimated cost of the ICT third-party service
          provider - <span>0100</span>
        </p>
        <AdditionalInformation
          description="Annual expense or estimated cost for using the ICT services provided by the ICT third-party service provider to the entities making use of the ICT services. Monetary value shall be reported in units.
(monetary)
(mandatory if the ICT third- party service provider is a direct ICT third-party service provider)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'total_annual_expense',
    key: 'total_annual_expense',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Identification code of the ICT third-party service provider’s ultimate
          parent undertaking - <span>0110</span>
        </p>
        <AdditionalInformation
          description="Code to identify the ICT third-party service provider’s ultimate parent undertaking.
The code used to identify ultimate parent undertaking in this field shall match the identification code provided in B_05.01.0010 for that ultimate parent undertaking.
Where the ICT third-party service provider is not part of a group, the identification code used to identify that ICT third- party service provider in B_05.01.0010 shall be repeated also in this data field.
(alphanumerical)
(mandatory if the ICT third- party service provider is not the ultimate parent undertaking)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'identification_code_of_ICT_providers_ultimate_parent',
    key: 'identification_code_of_ICT_providers_ultimate_parent',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of code to identify the ICT third-party service provider’s
          ultimate parent undertaking - <span>0120</span>
        </p>
        <AdditionalInformation
          description="Type of code to identify the ICT third-party service provider’s ultimate parent undertaking in B_05.01.0110.
The type of the code used to identify ultimate parent undertaking in this field shall match the identification code provided in B_05.01.0020 for that ultimate parent undertaking. Where the ICT third-party service provider is not part of a group, the type of the identification code used to identify that ICT third-party service provider in B_05.01.0020 shall be repeated also in this data field.
(pattern)
(mandatory if the ICT third- party service provider is not the ultimate parent undertaking)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'type_of_code_to_identify_ultimate_parent',
    key: 'type_of_code_to_identify_ultimate_parent',
  },
  {
    title: 'Name of the financial entity',
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0502: TableColumnsType<DataTypeB0502> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Contractual arrangement reference number - <span>0010</span>
        </p>
        <AdditionalInformation
          description="As reported in B_02.01.0010
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'contractual_arrangement_ref_number',
    key: 'contractual_arrangement_ref_number',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of ICT services - <span>0020</span>
        </p>
        <AdditionalInformation
          description="One of the types of ICT services referred to in Annex III
(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'type_of_ICT',
    key: 'type_of_ICT',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Identification code of the ICT third-party service provider -
          <span>0030</span>
        </p>
        <AdditionalInformation
          description="As reported in B_05.01.0010 for that ICT third-party service provider.
Examples:
—	The identification code of the direct ICT third- party service provider providing ICT service to the financial entity making use of it;
—	The identification code of the subcontractor at rank 2 providing service to the direct ICT third- party service provider.
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'identification_code_of_ICT_provider',
    key: 'identification_code_of_ICT_provider',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of code to identify the ICT third-party service provider -
          <span>0040</span>
        </p>
        <AdditionalInformation
          description="Type of code to identify the ICT third-party service provider reported in B_05.01.0010
1.	‘LEI’ for LEI
2.	‘EUID’ for EUID
3.	‘Country Code’+Underscore+’Type of Code’ for non LEI and non EUID code
Country Code: Identify the ISO 3166–1 alpha–2 code of the country of issuance of the other code to identify the ICT third- party service provider
Type of Code:
1.	CRN for Corporate registration number
2.	VAT for VAT number
3.	PNR for Passport Number
4.	NIN for National Identity Number
Only LEI or EUID shall be used for legal persons, as identified in B_05.01.0070, whereas alternative code may be used only for an individual acting in a business capacity.
Only LEI shall be used for legal persons that are not established in the Union.
(pattern)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'type_of_code_to_identify_provider',
    key: 'type_of_code_to_identify_provider',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Rank - <span>0050</span>
        </p>
        <AdditionalInformation
          description="Where the ICT third-party service provider is signing the contractual arrangement with the financial entity, it is considered as a direct ICT third-party service provider and the ‘rank’ to be reported shall be 1;
Where the ICT third-party service provider is signing the contract with the direct ICT third-party service provider, it is considered as a subcontractor and the ‘rank’ to be reported shall be 2;
The same logic apply to all the following subcontractors by incrementing the ‘rank’.
Where multiple ICT third-party service providers have the same ‘rank’ in the ICT service supply chain, financial entities shall report the same ‘rank’ for all those ICT third-party service providers.
(natural number)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'rank',
    key: 'rank',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Identification code of the recipient of sub-contracted ICT services -
          <span>0060</span>
        </p>
        <AdditionalInformation
          description="To be left blank if the ICT third-party service provider (template B_05.02.0030) is a direct ICT third-party service provider i.e. at ‘rank’ r = 1 (template B_05.02.0050);
Where the ICT third-party service provider is at ‘rank’ r = n where n>1, indicate the ‘Identification code of the recipient of the sub-contracted services’ at ‘rank’ r=n-1 that subcontracted the ICT service (even partially) to the ICT third-party service provider at ‘rank’ r=n.
Examples:
—	The identification code of the direct ICT third- party service provider receiving the service from the subcontractor at rank 2;
—	The identification code of the subcontractor at rank 2 receiving the service from the subcontractor at rank 3.
The code used to identify the recipient of sub- contracted ICT services shall match the identification code provided in B_05.01.0010 for that provider.
(alphanumerical)
(mandatory Not applicable for rank 1)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'identification_code_of_recipient',
    key: 'identification_code_of_recipient',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of code to identify the recipient of sub-contracted ICT services
          - <span>0070</span>
        </p>
        <AdditionalInformation
          description="To be left blank where the ICT third-party service provider template B_05.02.0030) is at rank r = 1 (template B_05.02.0050);
Where the ICT third-party service provider is at ‘rank’ r = n where n>1, indicate the ‘Type of code to identify the recipient of the sub-contracted service’ at ‘rank’ r=n-1 that subcontracted the ICT service (even partially) to the ICT third-party service provider at ‘rank’ r=n.
1.	‘LEI’ for LEI
2.	‘EUID’ for EUID
3.	CRN for Corporate registration number
4.	VAT for VAT number
5.	PNR for Passport Number
6.	NIN for National Identity Number
The type of code used to identify the recipient of sub- contracted ICT services shall match the identification code provided in B_05.01.0020 for that provider.
(pattern)
(mandatory Not applicable for rank 1)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'type_of_code_to_identify_recipient',
    key: 'type_of_code_to_identify_recipient',
  },
  {
    title: 'Name of the financial entity',
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0601: TableColumnsType<DataTypeB0601> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Function Identifier - <span>0010</span>
        </p>
        <AdditionalInformation
          description="The function identifier shall be composed by the letter F (capital letter) followed by a natural number (e.g. “F1” for the 1st function identifier and “Fn” for the nth function identifier with “n” being a natural number).
Each combination between ‘LEI of the financial entity making use of the ICT service(s)’ (B_06.01.0040), ‘Function name’ (B_06.01.0030) and ‘Licenced activity’ (B_06.01.0020) shall have a unique function identifier.
Example: a financial entity which operates under two licensed activities (‘activity A’ and ‘activity B’) will be given two unique ‘function identifiers’ for the same function X (e.g. Sales) performed for activity A and activity B.
(pattern)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'function_identifier',
    key: 'function_identifier',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Licenced activity - <span>0020</span>
        </p>
        <AdditionalInformation description="One of the licenced activities referred to in the underlying legal acts listed in Annex II for the different types of financial entities. Where the function is not linked to a registered or licenced activity, 'support functions' shall be reported." />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'licenced_identifier',
    key: 'licenced_identifier',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Function name - <span>0030</span>
        </p>
        <AdditionalInformation
          description="Function name according to the financial entity’s internal organisation.
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'function_name',
    key: 'function_name',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          LEI of the financial entity - <span>0040</span>
        </p>
        <AdditionalInformation
          description="As reported in B_04.01.0020
Identify the financial entity using the LEI, 20-character, alpha-numeric code based on the ISO 17442 standard
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'lei_of_financial_entity',
    key: 'lei_of_financial_entity',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Criticality or importance assessment - <span>0050</span>
        </p>
        <AdditionalInformation
          description="Use this column to indicate whether the function is critical or important according to the financial entity’s assessment. One of the options in the following closed list shall be used:
1.	Yes;
2.	No;
3.	Assessment not performed.
(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'criticality_assessment',
    key: 'criticality_assessment',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Reasons for criticality or importance - <span>0060</span>
        </p>
        <AdditionalInformation
          description="Brief explanation on the reasons for classifying the function as critical or important (300 characters maximum)
(alphanumerical)
(optional)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'reasons_for_criticality',
    key: 'reasons_for_criticality',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Date of the last assessment of criticality or importance -
          <span>0070</span>
        </p>
        <AdditionalInformation
          description="Identify the date using ISO 8601 (yyyy– mm–dd) code of the date of the last assessment of criticality or importance in case the function is supported by ICT services provided by ICT third-party service providers.
Where the assessment of the function’s criticality or importance is not performed, it shall be filled in with ‘9999-12-31’
(date)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'date_of_last_assessment',
    key: 'date_of_last_assessment',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Recovery time objective of the function - <span>0080</span>
        </p>
        <AdditionalInformation
          description="In number of hours. Where the recovery time objective is less than 1 hour, ‘1’ shall be reported. Where the recovery time objective of the function is not defined, ‘0’ shall be reported.
(natural number)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'recovery_time_objective',
    key: 'recovery_time_objective',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Recovery point objective of the function - <span>090</span>
        </p>
        <AdditionalInformation
          description="In number of hours. Where the recovery point objective is less than 1 hour, ‘1’ shall be reported. Where the recovery point objective of the function is not defined, ‘0’ shall be reported.
(natural number)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'recovery_point_objective',
    key: 'recovery_point_objective',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Impact of discontinuing the function - <span>0100</span>
        </p>
        <AdditionalInformation
          description="Use this column to indicate the impact of discontinuing the function according to the financial entity’s assessment. One of the options in the following closed list shall be used:
1.	Low
2.	Medium;
3.	High;
4.	Assessment not performed.
(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'impact_of_discontinuing_function',
    key: 'impact_of_discontinuing_function',
  },
  {
    title: 'Name of the financial entity',
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const columnsB0701: TableColumnsType<DataTypeB0701> = [
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Contractual arrangement reference number - <span>0010</span>
        </p>
        <AdditionalInformation
          description="As reported in B_02.01.0010
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'contractual_arrangement_reference_number',
    key: 'contractual_arrangement_reference_number',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Identification code of the ICT third-party service provider -
          <span>0020</span>
        </p>
        <AdditionalInformation
          description="As reported in B_05.01.0010
(alphanumerical)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'identification_code_of_ICT_provider',
    key: 'identification_code_of_ICT_provider',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of code to identify the ICT third-party service provider -
          <span>0030</span>
        </p>
        <AdditionalInformation
          description="Type of code to identify the ICT third-party service provider reported in B_05.01.0010
          1.	‘LEI’ for LEI
          2.	‘EUID’ for EUID
          3.	‘Country Code’+Underscore+’Type of Code’ for non LEI and non EUID code
          Country Code: Identify the ISO 3166–1 alpha–2 code of the country of issuance of the other code to identify the ICT third- party service provider
          Type of Code:
          1.	CRN for Corporate registration number
          2.	VAT for VAT number
          3.	PNR for Passport Number
          4.	NIN for National Identity Number
          Only LEI or EUID shall be used for legal persons, as identified in B_05.01.0070, whereas alternative code may be used only for an individual acting in a business capacity.
          Only LEI shall be used for legal persons that are not established in the Union.
          (pattern)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'type_of_code_of_ICT_provider',
    key: 'type_of_code_of_ICT_provider',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Type of ICT services - <span>0040</span>
        </p>
        <AdditionalInformation
          description="One of the types of ICT services referred to in Annex III
(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'type_of_ICT_services',
    key: 'type_of_ICT_services',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Substitutability of the ICT third-party service provider -
          <span>0050</span>
        </p>
        <AdditionalInformation
          description="Use this column to provide the results of the financial entity’s assessment in relation to the degree of substitutability of the ICT third- party service provider to perform the specific ICT services supporting a critical or important function.
One of the options in the following closed list shall be used:
1.	Not substitutable;
2.	Highly complex substitutability;
3.	Medium	complexity	in	terms	of substitutability;
4.	Easily substitutable.
(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'sustainability_of_ICT_provider',
    key: 'sustainability_of_ICT_provider',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Reason if the ICT third-party service provider is considered not
          substitutable or difficult to be substitutable - <span>0060</span>
        </p>
        <AdditionalInformation
          description="One of the options in the following closed list shall be used:
1.	The lack of real alternatives, even partial, due to the limited number of ICT third- party service providers active on a specific market, or the market share of the relevant ICT third-party service provider, or the technical complexity or sophistication involved, including in relation to any proprietary technology, or the specific features of the ICT third- party service provider’s organisation or activity;
2.	Difficulties in relation to a partial or full migration of the relevant data and workloads from the relevant ICT third- party service provider to another ICT third-party service provider or by reintegrating them in the financial entity’s operations, due either to significant financial costs, time or other resources that the migration process may entail, or to an increased ICT risk or other operational risks to which the financial entity might be exposed;
3.	Both reasons referred to in points 1 and 2.
(closed set of options)
(mandatory in case “not substitutable” or “highly complex substitutability” is selected in B_07.01.0041)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'reason_of_substitutable',
    key: 'reason_of_substitutable',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Date of the last audit on the ICT third-party service provider -
          <span>0070</span>
        </p>
        <AdditionalInformation
          description="Use this column to provide the date of the last audit on the specific ICT services provided by the ICT third-party service provider.
This column relates to audits conducted by any of the following:
(a)	the internal audit department or any other additional qualified personnel of the financial entity;
(b)	a joint team together with other clients of the same ICT third-party service provider (‘pooled audit’);
(c)	a third party appointed by the supervised entity to audit the service provider.

This column does not relate to the reception or reference date of third-party certifications or internal audit reports of the ICT third- party service provider, the annual monitoring date of the arrangement by the financial entity or the date of review of the risk assessment performed by the financial entity.
This column shall be used to report all types of audits performed by any of the subjects referred to in points (a), (b) and (c) concerning fully or partially the ICT services provided by the ICT third-party service provider.
To report the date, the ISO 8601 (yyyy– mm–dd) code shall be used.
Where no audit has been performed, it shall be filled in with ‘9999-12-31’.
(date)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'date_of_last_audit',
    key: 'date_of_last_audit',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Existence of an exit plan - <span>0080</span>
        </p>
        <AdditionalInformation
          description="Use this column to report the existence of an exit plan from the ICT third-party service provider in relation to the specific ICT service provided.
One of the options in the following closed list shall be used:
1.	Yes;
2.	No.
[Yes/No]"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'existance_of_exit_plan',
    key: 'existance_of_exit_plan',
    render: (value) =>
      value === null || value === undefined
        ? ''
        : value === 'true'
          ? 'Yes'
          : 'No',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Possibility of reintegration of the contracted ICT service -
          <span>0090</span>
        </p>
        <AdditionalInformation
          description="One of the options in the following closed list shall be used:
1.	Easy;
2.	Difficult;
3.	Highly complex.
Use this column where the ICT service is provided by an ICT third-party service provider that is not an ICT intra-group service provider
(closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'possibility_of_reintegration',
    key: 'possibility_of_reintegration',
    render: (value) =>
      value === null || value === undefined
        ? ''
        : value === 'true'
          ? 'Yes'
          : 'No',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Impact of discontinuing the ICT services - <span>0100</span>
        </p>
        <AdditionalInformation
          description="Use this column to provide the impact for the financial entity of discontinuing the ICT services provided by the ICT third-party service provider according to the financial entity’s assessment.
            One of the options in the following closed list shall be used:
            1.	Low
            2.	Medium;
            3.	High;
            4.	Assessment not performed.
            (closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'impact_of_discontinuing_ICT_services',
    key: 'impact_of_discontinuing_ICT_services',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Are there alternative ICT third-party service providers identified? -
          <span>0110</span>
        </p>
        <AdditionalInformation
          description="One of the options in the following closed list shall be used:
          1.	Yes;
          2.	No;
          7. Assessment not performed.
          For each ICT third-party service provider supporting a critical or important function, the assessment to identify an alternative service provider shall be performed.
          (closed set of options)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'alternative_ICT_identified',
    key: 'alternative_ICT_identified',
    render: (value) =>
      value === null || value === undefined
        ? ''
        : value === 'true'
          ? 'Yes'
          : 'No',
  },
  {
    title: (
      <Styled.AddttionalInfoContainer>
        <p>
          Identification of alternative ICT TPP - <span>0120</span>
        </p>
        <AdditionalInformation
          description="If ‘Yes’ is reported in B_07.01.0110, additional information may be provided in this column
(optional)"
        />
      </Styled.AddttionalInfoContainer>
    ),
    width: 200,
    dataIndex: 'identification_of_alternative_ICT_TPP',
    key: 'identification_of_alternative_ICT_TPP',
  },
  {
    title: 'Name of the financial entity',
    width: 200,
    dataIndex: 'entity_name',
    key: 'entity_name',
  },
  {
    title: 'Selected Date',
    width: 200,
    dataIndex: 'date',
    key: 'date',
  },
];

export const roleColumns: ColumnsType<IRoles & { _isFirstRow?: boolean }> = [
  {
    title: 'Name of the entity',
    render: (_, record) => (record._isFirstRow ? record.entity_name : ''),
    width: 120,
  },
  {
    title: 'Entity Reporting Date',
    render: (_, record) =>
      record._isFirstRow ? record.entity_reporting_date : '',
    width: 120,
  },
  { title: 'Role Name', dataIndex: 'role_name', width: 120 },
  { title: 'Role Description', dataIndex: 'role_description', width: 120 },
  { title: 'Role Type', dataIndex: 'role_type', width: 120 },
  {
    title: 'Responsibility Name',
    dataIndex: 'responsibility_name',
    width: 120,
  },
  {
    title: 'Responsibility Description',
    dataIndex: 'responsibility_description',
    width: 120,
  },
];

export const responsibilityColumns: TableColumnsType<IResponsibility> = [
  {
    title: 'Responsibility Description',
    dataIndex: 'responsibility_description',
    width: 320,
  },
  { title: 'Responsibility Name', dataIndex: 'responsibility_name' },
  { title: 'Start Date', dataIndex: 'responsibility_start_date' },
  { title: 'End Date', dataIndex: 'responsibility_end_date' },
];

export const columnsRiskSource: TableColumnsType<IIctRisk> = [
  {
    title: 'Name of the financial entity',
    dataIndex: 'entity_name',
    key: 'entity_name',
    width: 120,
  },
  {
    title: 'Entity reporting date',
    dataIndex: 'entity_reporting_date',
    key: 'entity_reporting_date',
    width: 120,
  },
  {
    title: 'ICT risk active',
    dataIndex: 'ict_risk_active',
    key: 'ict_risk_active',
    width: 120,
  },
  {
    title: 'ICT risk description',
    dataIndex: 'ict_risk_description',
    key: 'ict_risk_description',
    width: 120,
  },
  {
    title: 'ICT risk name',
    dataIndex: 'ict_risk_name',
    key: 'ict_risk_name',
    width: 120,
  },
  {
    title: 'ICT risk end date',
    dataIndex: 'ict_risk_end_date',
    key: 'ict_risk_end_date',
    width: 120,
  },
  {
    title: 'ICT risk start date',
    dataIndex: 'ict_risk_start_date',
    key: 'ict_risk_start_date',
    width: 120,
  },
  {
    title: 'ICT system name',
    dataIndex: 'ict_system_name',
    key: 'ict_system_name',
    width: 120,
  },
  {
    title: 'ICT system description',
    dataIndex: 'ict_system_description',
    key: 'ict_system_description',
    width: 120,
  },
  {
    title: 'Risk exposure description',
    dataIndex: 'risk_exposure_description',
    key: 'risk_exposure_description',
    width: 120,
  },
  {
    title: 'Risk exposure name',
    dataIndex: 'risk_exposure_name',
    key: 'risk_exposure_name',
    width: 120,
  },
  {
    title: 'Risk level description',
    dataIndex: 'risk_level_description',
    key: 'risk_level_description',
    width: 120,
  },
  {
    title: 'Risk level name',
    dataIndex: 'risk_level_name',
    key: 'risk_level_name',
    width: 120,
  },
  {
    title: 'Risk source name',
    dataIndex: 'risk_source',
    key: 'risk_source_name',
    width: 120,
    render: (sources) =>
      sources.map((s: IRiskSource) => s.risk_source_name).join(', '),
  },
  {
    title: 'Risk source description',
    dataIndex: 'risk_source',
    key: 'risk_source_description',
    width: 120,
    render: (sources) =>
      sources.map((s: IRiskSource) => s.risk_source_description).join(', '),
  },
];

export const columnsRiskExposure: TableColumnsType<IIctRiskExposure> = [
  {
    title: 'Entity name',
    dataIndex: 'entity_name',
    key: 'entity_name',
    width: 120,
  },
  {
    title: 'Entity reporting date',
    dataIndex: 'entity_reporting_date',
    key: 'entity_reporting_date',
    width: 120,
  },
  {
    title: 'Contract name',
    dataIndex: 'contract_name',
    key: 'contract_name',
    width: 120,
  },
  {
    title: 'ICT Service name',
    dataIndex: 'ict_service_name',
    key: 'ict_service_name',
    width: 120,
  },
  {
    title: 'TPP name',
    dataIndex: 'tpp_name',
    key: 'tpp_name',
    width: 120,
  },
  {
    title: 'Dependency type name',
    dataIndex: 'dependency_type_name',
    key: 'dependency_type_name',
    width: 120,
  },
  {
    title: 'Dependency type description',
    dataIndex: 'dependency_type_description',
    key: 'dependency_type_description',
    width: 120,
  },
  {
    title: 'Exposure category name',
    dataIndex: 'exposure_category_name',
    key: 'exposure_category_name',
    width: 120,
  },
  {
    title: 'Exposure category description',
    dataIndex: 'exposure_category_description',
    key: 'exposure_category_description',
    width: 120,
  },
  {
    title: 'ICT risk name',
    dataIndex: 'ict_risk_name',
    key: 'ict_risk_name',
    width: 120,
  },
  {
    title: 'ICT system description',
    dataIndex: 'ict_system_description',
    key: 'ict_system_description',
    width: 120,
  },
  {
    title: 'Risk exposure name',
    dataIndex: 'risk_exposure_name',
    key: 'risk_exposure_name',
    width: 120,
  },
  {
    title: 'Risk exposure description',
    dataIndex: 'risk_exposure_description',
    key: 'risk_exposure_description',
    width: 120,
  },
  {
    title: 'Risk exposure start date',
    dataIndex: 'risk_exposure_start_date',
    key: 'risk_exposure_start_date',
    width: 120,
  },
  {
    title: 'Risk exposure end date',
    dataIndex: 'risk_exposure_end_date',
    key: 'risk_exposure_end_date',
    width: 120,
  },
];

export const columnsIctRisksFunctionServiceDetails: TableColumnsType<ICTRiskFunctionServiceDetails> =
  [
    {
      title: 'Entity name',
      dataIndex: 'entity_name',
      key: 'entity_name',
      width: 150,
    },
    {
      title: 'Entity reporting date',
      dataIndex: 'entity_reporting_date',
      key: 'entity_reporting_date',
      width: 150,
    },
    {
      title: 'Dependency type name',
      dataIndex: 'dependency_type_name',
      key: 'dependency_type_name',
      width: 150,
    },
    {
      title: 'Dependency type description',
      dataIndex: 'dependency_type_description',
      key: 'dependency_type_description',
      width: 150,
    },
    {
      title: 'Exposure category name',
      dataIndex: 'exposure_category_name',
      key: 'exposure_category_name',
      width: 150,
    },
    {
      title: 'Exposure category description',
      dataIndex: 'exposure_category_description',
      key: 'exposure_category_description',
      width: 150,
    },
    {
      title: 'Risk name',
      dataIndex: 'risk_name',
      key: 'risk_name',
      width: 150,
    },
    {
      title: 'Risk description',
      dataIndex: 'risk_description',
      key: 'risk_description',
      width: 150,
    },
    {
      title: 'ICT system name',
      dataIndex: 'ict_system_name',
      key: 'ict_system_name',
      width: 150,
    },
    {
      title: 'Risk exposure name',
      dataIndex: 'risk_exposure_name',
      key: 'risk_exposure_name',
      width: 150,
    },
    {
      title: 'Risk exposure description',
      dataIndex: 'risk_exposure_description',
      key: 'risk_exposure_description',
      width: 150,
    },
    {
      title: 'Risk exposure start date',
      dataIndex: 'risk_exposure_start_date',
      key: 'risk_exposure_start_date',
      width: 150,
    },
    {
      title: 'Risk exposure end date',
      dataIndex: 'risk_exposure_end_date',
      key: 'risk_exposure_end_date',
      width: 150,
    },
    {
      title: 'ICT risk name',
      dataIndex: 'ict_risk_name',
      key: 'ict_risk_name',
      width: 150,
    },
    {
      title: 'ICT risk start date',
      dataIndex: 'risk_start_date',
      key: 'risk_start_date',
      width: 150,
    },
    {
      title: 'ICT risk source name',
      dataIndex: 'risk_source_name',
      key: 'risk_source_name',
      width: 150,
    },
    {
      title: 'ICT risk level name',
      dataIndex: 'risk_level_name',
      key: 'risk_level_name',
      width: 150,
    },
    {
      title: 'ICT risk end date',
      dataIndex: 'risk_end_date',
      key: 'risk_end_date',
      width: 150,
    },
    {
      title: 'ICT system category name',
      dataIndex: 'ict_system_category_name',
      key: 'ict_system_category_name',
      width: 150,
    },
    {
      title: 'Function name',
      dataIndex: 'function_name',
      key: 'function_name',
      width: 150,
    },
  ];

export const ICTSystemFormatter = {
  riskName: (row: any) => row._risk?.ict_risk_name || '',
  riskDescription: (row: any) => row._risk?.ict_risk_description || '',
  site: (row: any) => row.ict_system_site || '',
  criticality: (row: any) => row.ict_system_criticality || '',
  functionName: (row: any) => row.function?.function_name || '',
  functionIdentifier: (row: any) => row.function?.function_identifier || '',
};

export const columnsICTSystemsForFunctions: TableColumnsType<any> = [
  { title: 'Name', key: 'name', render: (_, r) => r.name },
  {
    title: 'Description',
    key: 'description',
    render: (_, r) => r.description || '',
  },
  {
    title: 'Access Restricted',
    key: 'access_restricted',
    render: (_, r) => (r.access_restricted ? 'True' : 'False'),
  },
  {
    title: 'Function Name',
    key: 'function_name',
    render: (_, r) => ICTSystemFormatter.functionName(r),
  },
  {
    title: 'Function Identifier',
    key: 'function_identifier',
    render: (_, r) => ICTSystemFormatter.functionIdentifier(r),
  },
  {
    title: 'ICT Risk Name',
    key: 'risk_name',
    render: (_, r) => ICTSystemFormatter.riskName(r),
  },
  {
    title: 'ICT Risk Description',
    key: 'risk_desc',
    render: (_, r) => ICTSystemFormatter.riskDescription(r),
  },

  { title: 'Site', key: 'site', render: (_, r) => ICTSystemFormatter.site(r) },
  {
    title: 'Category Name',
    key: 'category_name',
    render: (_, r) => r.ict_system_category_name,
  },
  {
    title: 'Criticality',
    key: 'criticality',
    render: (_, r) => ICTSystemFormatter.criticality(r),
  },
];

export const columnsICTSystemsByServices = [
  {
    title: 'System Name',
    dataIndex: 'name',
  },
  {
    title: 'Description',
    dataIndex: 'description',
  },
  {
    title: 'Category',
    dataIndex: 'ict_system_category_name',
  },
  {
    title: 'Type',
    dataIndex: 'ict_system_type_name',
  },
  {
    title: 'Site',
    dataIndex: 'ict_system_site',
  },
  {
    title: 'Risk Name',
    render: (_: any, record: any) => record._risk?.ict_risk_name ?? '-',
  },
  {
    title: 'Risk Description',
    render: (_: any, record: any) => record._risk?.ict_risk_description ?? '-',
  },
  {
    title: 'Start Date',
    dataIndex: 'start_date',
  },
  {
    title: 'End Date',
    dataIndex: 'end_date',
  },
];
